module.exports = __webpack_public_path__ + "static/media/team-health-pool-cartao-visita.4ece9b98.jpg";